/**
 * This function use Object.keys to extract the keys of an object and return correct types for the keys
 */
export function keyExtractor(object) {
    return Object.keys(object);
}
